import { render, staticRenderFns } from "./LProjectViewObjectContent.vue?vue&type=template&id=124bd33d&scoped=true&"
import script from "./LProjectViewObjectContent.vue?vue&type=script&lang=js&"
export * from "./LProjectViewObjectContent.vue?vue&type=script&lang=js&"
import style0 from "./LProjectViewObjectContent.vue?vue&type=style&index=0&id=124bd33d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124bd33d",
  null
  
)

export default component.exports